module.exports = Em.ObjectController.extend({
    selected: false,

    url: function() {
        return this.container.lookup('router:main').generate(Em.String.underscore(this.get('originType')), this.get('originId'))
    }.property('originType', 'originId')
})
